import script from "./ConceptComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConceptComponent.vue?vue&type=script&setup=true&lang=js"

import "./ConceptComponent.vue?vue&type=style&index=0&id=62c7ec8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c7ec8f"]])

export default __exports__